import React from 'react';
import clsx from 'clsx';

import './index.scss';

import RadioInput from 'components/atoms/Input/RadioInput';

const PcAccordionRadioNote = ({
  // checkbox
  id,
  value,
  checked,
  label,
  onChange,
  note
}) =>{
  return(
    <div className="PcAccordionRadioNote">
      <div className="pc-accordion-radio-text-area-wrapper">
        <RadioInput
          id={id}
          value={value}
          checked={checked} 
          label={label} 
          onChange={onChange}
          note={note}
        />
        <div className={clsx('pc-cmnt-area', { checked })}>
          <div className="arrowArea">
            <div className="pc-background-cmnt" />
          </div>
          <div className="pcCollpseAreaBackground">
            {note}
          </div>
        </div>
      </div>
    </div>

  );
};

export default PcAccordionRadioNote;